<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div
          class="cd-search-form-wrap"
          :class="showMoreSearch ? 'style-show-more' : 'style-hide-more'"
        >
          <el-form
            ref="searchForm"
            :model="searchFormData"
            class="cd-search-form"
            label-width="80px"
          >
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="文章ID:" prop="area_id_arr">
                  <el-input
                    placeholder="输入文章ID"
                    v-model="searchFormData.id"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="所属分类:" prop="article_category_id">
                  <!-- <el-select
                    filterable
                    placeholder="请选择"
                    v-model="searchFormData.article_category_id"
                    clearable
                  >
                    <el-option
                      v-for="item in categoryList"
                      :key="item.id"
                      :label="item.category_name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select> -->
                  <!-- 级联选择器 -->
                     <el-cascader
                      v-model="searchFormData.article_category_id"
                      :options="categoryList"
                      :props="{ checkStrictly: true, children:'child',label: 'category_name',value: 'id'  }"
                      clearable>
                    </el-cascader>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="文章标题:" prop="title">
                  <el-input
                    placeholder="请输入文章标题"
                    v-model="searchFormData.title"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="审核状态:" prop="ispublish">
                  <el-select
                    placeholder="请选择"
                    v-model="searchFormData.ispublish"
                    clearable
                    ref="examine_select"
                    @visible-change="visibleChange($event, 'examine_select')"
                  >
                    <el-option
                      v-for="item in publishList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="删除状态:" prop="is_del">
                  <el-select
                    placeholder="请选择"
                    v-model="searchFormData.is_del"
                    clearable
                    ref="delete_select"
                    @visible-change="visibleChange($event, 'delete_select')"
                  >
                    <el-option
                      v-for="item in delList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
               <el-col :span="9">
                <el-form-item label="发布时间:">
                  <el-date-picker
                    @change="pushTimeFn"
                    v-model="searchFormData.pushTime"
                    type="daterange"
                    value-format="timestamp"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="发生时间:">
                  <el-date-picker
                    @change="openTimeFn"
                    v-model="searchFormData.openTime"
                    type="daterange"
                    value-format="timestamp"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="发生地区:" prop="occurred_area_id">
                  <el-select
                    filterable
                    placeholder="请选择"
                    v-model="searchFormData.occurred_area_id"
                    clearable
                    ref="region_select"
                    @visible-change="visibleChange($event, 'region_select')"
                  >
                    <el-option
                      v-for="item in areaList"
                      :key="item.id"
                      :label="item.full_area_name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item label="事件类型:" prop="cat_id">
                  <el-select
                    placeholder="请选择"
                    v-model="searchFormData.cat_id"
                    clearable
                  >
                    <el-option
                      v-for="item in $enums.CollectSourceType.list"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="事件主体:" prop="cat_id">
                  <el-select
                    placeholder="请选择"
                    v-model="searchFormData.cat_id"
                    clearable
                  >
                    <el-option
                      v-for="item in $enums.CollectSourceType.list"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="6">
                <el-form-item label="发布人:" prop="create_admin_id">
                  <el-select
                    placeholder="请选择"
                    v-model="searchFormData.create_admin_id"
                    clearable
                    filterable
                    ref="publisher_select"
                    @visible-change="visibleChange($event, 'publisher_select')"
                  >
                    <el-option
                      v-for="item in memberList"
                      :key="item.id"
                      :label="item.username"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="事件类型:" prop="article_event_category_id">
                     <el-cascader
                      v-model="searchFormData.article_event_category_id"
                      :options="categoryTypeList"
                      :props="{emitPath: false, multiple: true,checkStrictly: true, children:'child',label: 'category_name',value: 'id'  }"
                      clearable>
                    </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="searchFormData.article_category_id == 1">
                <el-form-item label="是否涉华:" prop="is_related_china">
                  <el-select
                    placeholder="请选择"
                    v-model="searchFormData.is_related_china"
                    clearable
                    ref="relatedChina_select"
                    @visible-change="visibleChange($event, 'relatedChina_select')"
                  >
                    <el-option
                      v-for="item in relatedChinaList"
                      :key="item.label"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="searchFormData.article_category_id == 1">
                <el-form-item label="华人作案:" prop="chinese_commit_crimes">
                  <el-select
                    placeholder="请选择"
                    v-model="searchFormData.chinese_commit_crimes"
                    clearable
                    ref="chinese_commit_crimes"
                    @visible-change="visibleChange($event, 'chinese_commit_crimes')"
                  >
                    <el-option
                      v-for="item in chinese_commit_crimes_list"
                      :key="item.label"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="show-more-toggle-wrapper">
          <div class="show-more-toggle-btn" @click="toggleShowMore">
            <i
              :class="
                showMoreSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
              "
            ></i>
            <span>{{ showMoreSearch ? "收起筛选条件" : "展开筛选条件" }}</span>
          </div>
        </div>

        <div style="text-align: right;margin-bottom: 10px;">
          <el-button type="primary" @click="getCDQueryData" @keyup.enter.native="enterFn()">查询</el-button>
          <el-button type="danger" :loading="loading" @click="doExport('1')">{{loadingTxt}}</el-button>
          <el-button type="info" @click="resetQueryClick">重置</el-button>
        </div>

        <div class="batch" style="margin-bottom: 10px">
          <el-button type="primary" @click="batchHandle">批量审核成功</el-button>
          <el-button type="danger" @click="batchDel">批量审核失败</el-button>
          <el-button @click="addArticleFn">新增文章</el-button>
          <span v-if="selectLen > 0" style="margin-left: 10px; color: gray">(已选：{{selectLen}})</span>
          <div class="batch_right" style="float: right">
            <el-button type="primary" @click="batchTranslate(1)">分类管理</el-button>
            <el-button type="primary" @click="batchTranslate(2)">字段管理</el-button>
            <el-button type="primary" @click="batchTranslate(3)">评论管理</el-button>
            <el-button type="primary" @click="batchTranslate(4)">事件类型管理</el-button>
          </div>
        </div>
        <zv-table :table="table" @on-selection-change="handleSelectionChange" ref="dataTable"></zv-table>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
import formPageMixin from "@/mixins/formPageMixin";
import TipUtil from "@/utils/utils/TipUtil";
import Tips from "@/utils/utils/Tips";
export default {
  name: "CollectDataList",
  mixins: [addFormMixin, formPageMixin],
  components: {},
  data() {
    let vm = this;
    return {
      value:[],
      // 查询条件ori
      selectLen: '',
      batchIds: "",
      publishList: [
        { label: '待审核', value: 0},
        { label: '审核通过', value: 1},
        { label: '审核失败', value: 2}
      ],
      relatedChinaList: [
        {
          label: '是'
        },
        {
          label: '否'
        }
      ],
      chinese_commit_crimes_list: [
        {
          label: '是'
        },
        {
          label: '否'
        }
      ],
      delList: [
        { label: '未删除', value: 0},
        { label: '已删除', value: 1}
      ],
      showMoreSearch: true,
      searchFormData: {},
      publish_time_begin_str: "",
      publish_time_end_str: "",
      add_time_begin_str: "",
      add_time_end_str: "",
      areaList: [], // 国家数组
      languageList: [], // 语言列表
      sourceList: [], // 信息源列表
      selectTagValue: "", // 下拉选择选中的tag值
      selectTagsList: [], // 所有tag 列表
      keywordsTypes: [
        {
          label: "标题",
          value: 1
        },
        {
          label: "内容",
          value: 2
        }
      ],
      table: {
        api: api.articleList,
        query: {},
        columns: [
          {
            type:"selection",
            width:"55"
          },
          {
            title: "标题",
            key: "title",
            minWidth: "250",
            showTooltip: true,
            render(h, ctx) {
              const status1 = h(
                "span",
                ctx.row.title
              );

              const status2 = h(
                "span",
                {
                  style:"color: red;margin-left: 10px",
                },
                ctx.row.is_del == 1 ? "已删除":""
              );
              let arr = [];
              arr.push(status1);
              arr.push(status2);

              return h("span", arr);
            }
          },
          {
            title: "类别",
            key: "category_name",
            minWidth: "80",
          },
          {
            title: "信息来源",
            key: "source",
            minWidth: "80",
          },
          {
            title: "地区",
            key: "area_full_name",
            minWidth: "80",
          },
          {
            title: "状态",
            key: "ispublish",
            minWidth: "140",
            render(h, ctx) {
              const status1 = h(
                "p",
                ctx.row.ispublish == 0 ? '待审核':ctx.row.ispublish == 1 ? '审核通过':'审核失败'
                
              );

              const status2 = h(
                "p",
                "审核人：" + ctx.row.publish_username
              );
              let arr = [];
              arr.push(status1);
              arr.push(status2);

              return h("span", arr);
            }
          },
          {
            title: "发布时间",
            key: "add_time",
            minWidth: "110",
            showTooltip: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.add_time));
            }
          },
          {
            title: "发生时间",
            key: "occurrence_time",
            minWidth: "110",
            showTooltip: true,
            sortable: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.occurrence_time/1000));
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "140",
            render(h, ctx) {
              const status1 = h(
                "p",
                ctx.row.last_admin_username
                
              );

              const status2 = h(
                "p",
                vm.$commFunc.formatDate(ctx.row.last_admin_time)
              );
              let arr = [];
              arr.push(status1);
              arr.push(status2);

              return h("span", arr);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth: "180",
            render(h, ctx) {
              const lookBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doViewDetail.bind(this, ctx.row.id)
                  }
                },
                "观点"
              );

              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doViewDetail.bind(this, ctx.row.id)
                  }
                },
                "编辑"
              );


              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doDeleteFn.bind(this, ctx.row)
                  }
                },

                ctx.row.is_del == 0 ? "删除":"恢复"
              );

              const commentBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doComment.bind(this, ctx.row)
                  }
                },
                "查看评论"
              );

              let arr = [];
              arr.push(lookBtn);
              arr.push(editBtn);

              arr.push(delBtn);
              arr.push(commentBtn);

              return h("span", arr);
            }
          }
        ],
      },
      formDataOri: {
        app_name: ""
      },
      formRules: {
        app_name: [
          {
            required: true,
            message: "App名称不能为空",
            trigger: "blur"
          }
        ]
      },
      deleteApi: api.articleDel,
      deleteSuccessMsg: "删除文章成功",
      categoryList: [],
      categoryTypeList: [],
      memberList: [],
      loading: false,
      loadingTxt: "导出"
    };
  },
  watch: {
    searchFormData(val) {
      if(val.pushTime) {
        this.$set(this.searchFormData,"add_time_from",val.pushTime[0]/1000)
        this.$set(this.searchFormData,"add_time_to",val.pushTime[1]/1000)
      }
      if(val.openTime) {
        this.$set(this.searchFormData,"occurred_time_from",val.openTime[0]/1000)
        this.$set(this.searchFormData,"occurred_time_to",val.openTime[1]/1000)
      }
    }
  },
  created() {
    this.categoryListFn()
    this.getAreaList()
    this.memberListFn()
    this.eventCategoryListFn()
    this.enterFn()
    // this.getCDQueryData();
    // this.getAreaList();
    // this.getLanguageList();
    // this.getSourceList();
    // this.getCollectSourceTagList();
  },
  mounted() {
    // document.onkeydown =(e) => {
    //   e = window.event || e;
    //   if(this.$route.path=='/login'&&(e.code=='Enter'||e.code=='enter')){
    //     //调用登录事件方法
    //     this.getCDQueryData();
    //   }
    // }
    // this.enterFn()
    
  },
  methods: {
    // 时间触发
    pushTimeFn() {
      if(this.searchFormData.pushTime) {
        this.$set(this.searchFormData,"add_time_from",this.searchFormData.pushTime[0]/1000)
        this.$set(this.searchFormData,"add_time_to",this.searchFormData.pushTime[1]/1000)
      }else if(this.searchFormData.pushTime == null) {
        delete this.searchFormData.add_time_from
        delete this.searchFormData.add_time_to
      }
    },

    openTimeFn() {
      if(this.searchFormData.openTime) {
        this.$set(this.searchFormData,"occurred_time_from",this.searchFormData.openTime[0]/1000)
        this.$set(this.searchFormData,"occurred_time_to",this.searchFormData.openTime[1]/1000)
      }else if(this.searchFormData.openTime == null) {
        delete this.searchFormData.occurred_time_from
        delete this.searchFormData.occurred_time_to
      }
    },

    async getCDQueryData() {
      let searchData = {...this.searchFormData}
      
      if(this.searchFormData.article_category_id){
        if(this.searchFormData.article_category_id.length > 1){
          searchData.article_category_id = this.searchFormData.article_category_id[this.searchFormData.article_category_id.length-1]
        }else{
          searchData.article_category_id = this.searchFormData.article_category_id[0]
        }
      }

      if(this.searchFormData.article_event_category_id){
        this.searchFormData.article_event_category_id = this.searchFormData.article_event_category_id.toString()
      }

      if(searchData.article_category_id != 1){
        searchData.is_related_china = ''
      }
      searchData.page = 1
      this.$set(this.table, "query", searchData);
      this.$refs.dataTable.refresh();
    },
    // enter event
    enterFn(){
      document.onkeydown =(e) => {
        e = window.event || e;
        if(this.$route.path=='/data-input/articleList'&&(e.code=='Enter'||e.code=='enter')){
          this.getCDQueryData();
        }
      }
    },
    // flag--回调参数，name--自定义参数
    visibleChange(flag,name) {
      if (flag) {
        // 发布人
        if(name == 'publisher_select'){
          this.$refs.publisher_select.focus();
        }
        // 发生地区
        if(name == 'region_select'){
          this.$refs.region_select.focus();
        }
        // 审核状态
        if(name == 'examine_select'){
          this.$refs.examine_select.focus();
        }
        // 删除状态
        if(name == 'delete_select'){
          this.$refs.delete_select.focus();
        }
        // 是否涉华
        if(name == 'relatedChina_select'){
          this.$refs.relatedChina_select.focus();
        }
      } else {
        // 发布人
        if(name == 'publisher_select'){
          this.$refs.publisher_select.blur();
        }
        // 发生地区
        if(name == 'region_select'){
          this.$refs.region_select.blur();
        }
        // 审核状态
        if(name == 'examine_select'){
          this.$refs.examine_select.blur();
        }
        // 删除状态
        if(name == 'delete_select'){
          this.$refs.delete_select.blur();
        }
        // 是否涉华
        if(name == 'relatedChina_select'){
          this.$refs.relatedChina_select.blur();
        }
        // 是否涉华
        if(name == 'chinese_commit_crimes'){
          this.$refs.chinese_commit_crimes.blur();
        }
      }
    },
    /**
     * @Author: lafitewu
     * @Desc:导出数据
     */
    async doExport(index) {
      // this.showExportDialog = false;
      this.loading = true
      this.loadingTxt = "导出中"
      let query = {}
      if (index == "0") {
        query = this.$_.cloneDeep(this.table.query);
        query.pageNo = this.table.pagination.pageNo;
        // query.pageSize = this.table.pageSize;
        query.pageSize = this.table.pagination.total;
        query.export2excel = 1
        // 导出当前页数据
        // api.simCardPage(query);
      } else if (index == "1") {
        query = this.$_.cloneDeep(this.table.query);
        query.pageNo = this.table.pagination.pageNo;
        // query.pageSize = this.table.pageSize;
        query.pageSize = this.table.pagination.total;
        query.export2excel = 1
        // query = {
        //   export2excel: 1,
        //   pageNo: 1,
        //   pageSize: 99999
        // }
        // query = Object.assign(
        //   {},
        //   {cityMarketCode: 'gz'}
        // );
        
        // 导出全部数据
        // api.simCardAll(query);
      }
      // console.log(query);
      let res = await api.articleList(query)
      // console.log(res.key);
      let timer = setInterval(async ()=>{
        let export_res = await api.excelExport({key:res.key})
        if(export_res.error_code == 0) {
          this.loading = false
          this.loadingTxt = "导出"
          window.open(export_res.file, '_blank');
          clearInterval(timer)
          Tips.notify({
            type: "success",
            title: '导出成功',
            // message: _data.error_message,
            customClass: "zv-net-error-notify",
          });
        }
      },1000)
      // console.log(export_res);
      
    },

    async getAreaList() {
      // { area_type: 2}
      this.areaList = await this.$commFunc.getAreaList();
    },

    // 删除
    async doDeleteFn(row) {
      let msgs,alerts
      if(row.is_del == 0) {
        msgs = "确定删除该条记录？"
        alerts = "删除成功！"
      }else {
        msgs = "确定恢复该条记录？"
        alerts = "恢复成功！"
      }
      await this.$confirm(
        msgs,
        '提示',
        {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      let params = {
        id: row.id,
        is_del: row.is_del == 1 ? 0:1
      }
      
      await this.deleteApi(params)
      this.$message({
        message: alerts,
        type: 'success'
      })
      this.$refs.dataTable.refresh()
    },
   
    resetQueryClick() {
      this.searchFormData = {}
      // this.$refs.searchForm.resetFields();
      // this.publish_time_begin_str = "";
      // this.publish_time_end_str = "";
      // this.add_time_begin_str = "";
      // this.add_time_end_str = "";
    },

    toggleShowMore() {
      this.showMoreSearch = !this.showMoreSearch;
    },

    customDeleteParams(id) {
      return {
        id,
        status: 2
      };
    },
    // 国家下来菜单筛选
    selectAreaFn(val) {
      this.getSourceList(val.join(","))
    },
    // 多选操作
    handleSelectionChange(val) {
      let arrs = []
      val.forEach(item => 
        arrs.push(item.id)
      )
      this.selectLen = val.length
      this.batchIds = arrs.join(",")
    },
    // 批量删除
    async batchDel() {
      let res = await api.articlePublish({
        ispublish: 2,
        id: this.batchIds
      });
      if(res.error_code == 0) {
        TipUtil.message("批量审核成功！", "success");
        this.$refs.dataTable.refresh();
      }
    },
    // 批量处理
    async batchHandle() {
      // console.log(this.batchIds)
      let res = await api.articlePublish({
        id: this.batchIds,
        ispublish: 1
      });
      if(res.error_code == 0) {
        TipUtil.message("批量审核成功！", "success");
        this.$refs.dataTable.refresh();
      }
    },
    // 路由跳转
    batchTranslate(index) {
      let paths
      if(index == 1) {
        paths = '/data-input/category'
      }else if(index == 2){
        paths = '/data-input/articleField'
      }else if(index == 3){
        paths = '/data-input/commentManagement'
      }else {
        paths = '/data-input/eventType'
      }
      this.$router.push({
        path: paths
      })
    },
    doViewDetail(id) {
      let routeData = this.$router.resolve("/data-input/addArticle?id=" + id);
      window.open(routeData.href, '_blank');
    },
    addArticleFn() {
      let routeData = this.$router.resolve("/data-input/addArticle");
      window.open(routeData.href, '_blank');
      // this.$router.push("/data-input/addArticle")
    },

    doComment(row) {
      let routeData = this.$router.resolve("/data-input/viewComments?id=" + row.id + "&type=" + row.article_category_id);
      window.open(routeData.href, '_blank');
    },

    // 分类下拉菜单
    async categoryListFn() {
      let res = await api.categoryList({parent_id:0})
      this.categoryList = res.list
    },

    // 事件类型下拉菜单
    async eventCategoryListFn() {
      let res = await api.eventCategoryList({parent_id:0})
      this.categoryTypeList = res.list
      // console.log(this.categoryTypeList);
    },

    // 发布人下拉菜单
    async memberListFn() {
      let res = await api.memberList({
        pagesize: 9999
      })
      this.memberList = res.list
    },

  },
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.cd-search-form-wrap {
  position: relative;
  overflow: hidden;
  &.style-hide-more {
    height: 40px;
  }
}

.show-more-toggle-wrapper {
  display: flex;
  justify-content: center;
  padding: 5px 0 15px;
}
.show-more-toggle-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #999;
  font-size: 12px;
  i {
    margin-right: 5px;
  }
}
.cd-search-form {
  .el-form-item {
    margin-bottom: 10px;
  }

  .cdd-status-sec2 {
    display: flex;
  }

  .cdd-status-sec22 {
    margin-right: 5px;
    .el-tag + .el-tag {
      margin-left: 5px;
    }
  }
}
</style>